export default __webpack_public_path__ + "static/media/positionIcon.8986564a.svg";